<template>
  <base-create-form
    :create-form="createForm"
    :formTitle="formTitle"
    @submitForm="submitForm"
    @cancel="cancel"
  ></base-create-form>
</template>

<script>
import { BaseCreateForm } from "@/components/Base/index.js";
import sanitizer from "sanitizer";
import { ProgramDivisionService } from "../../../services/programDivision.service";
export default {
  name: "ProgramDivisionCreateForm",
  components: { BaseCreateForm },
  data() {
    return {
      formTitle: this.$t("page_title.program_division_create"),
      createForm: [
        {
          label: this.$t("program_division.name"),
          name: "name",
          value: "",
          type: "input",
          required: true,
          validateRule: "required"
        },
        {
          label: this.$t("program_division.description"),
          name: "description",
          value: "",
          type: "input",
          required: false,
          validateRule: ""
        }
      ]
    };
  },
  methods: {
    cancel() {
      this.$router.push({ name: "ProgramDivisionList" });
    },
    async submitForm(params) {
      const response = await new ProgramDivisionService().create(params);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("program_division.name"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "ProgramDivisionList" }), 500);
    }
  }
};
</script>

<style scoped></style>
